@if (showOtpCheckScreen) {
  <app-otp-check (cancel)="onOtpCancel()"></app-otp-check>
} @else if (showTooManyRequestsScreen) {
  <div class="request-rate-limit-screen">
    <p class="request-rate-limit-message">{{ tooManyRequestsMessage }}</p>
  </div>
} @else {
  <div class="card oui-card">
    <div class="card-body mb-4">
      <p class="mb-4" [innerHTML]="'HOME.Authentication' | labelText"></p>
      <form [formGroup]="authenticationForm">
        <div *ngIf="!isAuthorizedClient">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 mt-no-title">
              {{ 'HOME.ClientNumber' | labelText }}
              <app-tooltip [title]="'Home.ClientNumberTitle' | labelText" [tooltipPosition]="'bottom'"> </app-tooltip>
              <app-member-number-form-control
                [parentForm]="authenticationForm"
                [formControlName]="'socialNumberA'"
                class="no-title error-new-row"
                [title]="''"
              >
              </app-member-number-form-control>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5">
              <app-date-form-control
                [parentForm]="authenticationForm"
                [formControlName]="'dateOfBirth'"
                [title]="'Common.DateOfBirth' | labelText"
                [maxDate]="dobMaxDate"
                class="error-new-row"
                [ngClass]="{ wtihManualError: dobAuthValueIsNotInRangeLimit }"
              >
              </app-date-form-control>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4" *ngIf="dobAuthValueIsNotInRangeLimit">
              <div class="error-block">
                <span class="text"> {{ dobErrorBlockText }} </span>
              </div>
            </div>
          </div>
        </div>
      </form>

      @if (requestCodeAuthErrorMessage) {
        <div class="auth-error-message">{{ requestCodeAuthErrorMessage }}</div>
      }
    </div>
    <div class="warning auth">
      {{ 'HOME.GatherDocumentsToFinalizeSubcription' | labelText }}
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-12 text-center" *ngIf="!isAuthorizedClient">
      <button type="submit" class="btn btn-blue valider" (click)="onSubmitClientAuth()" [disabled]="!isAuthFormValid">
        {{ 'Common.Validate' | labelText }}
      </button>
    </div>

    @if (isBlockedProfile) {
      <div class="col-12 blocked-profile-message">
        <p>
          {{ 'Home.BlockedProfileText1' | labelText }} <br />
          {{ 'Home.BlockedProfileText2' | labelText }}
        </p>
      </div>
    }
  </div>
}
